module.exports = __webpack_public_path__ + "img/495.49a85c24.jpg";